import {http} from "@/config/HttpClient";
import {Alert} from "@/addons/Alert";
import {recaudacionStore} from "@/store/recaudacionStore";
import {globalStore} from "@/store/globalStore";
import {AxiosResponse} from "axios";
import {DateTime} from 'luxon';

export class RecaudacionService {
    private static instance: RecaudacionService;
    public static getInstance() {
        return this.instance || (this.instance = new this());
    }

    recaudacionStore = recaudacionStore();
    globalStore = globalStore();

    public async index(data: any) {
        this.recaudacionStore.loading = true;
        await http.get("cobranzas", {params: data}).subscribe({
            next: (response) => {
                this.recaudacionStore.facturas = response.data.data;
                this.makePagination(response.data);
                this.recaudacionStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.recaudacionStore.loading = false;
            }
        })
    }

    public async reporteIndex(data: any) {
        this.recaudacionStore.loading = true;
        await http.get("listadoRecaudacion", {params: data}).subscribe({
            next: (response) => {
                this.recaudacionStore.facturasCajero = response.data.datos;
                this.recaudacionStore.cantidadFacturas = response.data.cantidadFacturas;
                this.recaudacionStore.totalRecaudado = response.data.totalRecaudado;
                this.recaudacionStore.detalleCajero = response.data.detalleCajero;
                this.recaudacionStore.fechaLiteral = response.data.fechaLiteral;
                this.recaudacionStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.recaudacionStore.loading = false;
            }
        })
    }
    public async resumenTotalizado(data: any) {
        this.recaudacionStore.loading = true;
        await http.get("resumenTotalizado", {params: data}).subscribe({
            next: (response) => {
                this.recaudacionStore.resumenTotalizado = response.data.data;
                this.recaudacionStore.resumenTotalizadoTotales = response.data.totales;
                this.recaudacionStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.recaudacionStore.loading = false;
            }
        })
    }

    makePagination(page: any) {
        this.recaudacionStore.pagination.per_page = page.per_page;
        this.recaudacionStore.pagination.current_page = page.current_page;
        this.recaudacionStore.pagination.last_page = page.last_page;
    }

    public async getOtroIngreso(data: any) {
        this.recaudacionStore.loading = true;
        await http.get("getOtroIngreso", {params: data}).subscribe({
            next: (response) => {
                if (response.data.success) {
                    this.recaudacionStore.facturaOtroIngreso = response.data.factura;
                    this.recaudacionStore.facturaOtroIngreso.cuotas = response.data.cuotas;
                    //asignando cuenta si no tiene ci
                    const cliente = this.recaudacionStore.facturaOtroIngreso.cliente;
                    if ((cliente.ci == '' || cliente.ci == null) && cliente.cuenta)
                        this.recaudacionStore.facturaOtroIngreso.cliente.ci = cliente.cuenta;
                    //verificando si tiene o no email
                    this.recaudacionStore.facturaOtroIngreso.cliente.tieneEmail = cliente.email !== '' && cliente.email !== null && cliente.email !== undefined;

                    this.recaudacionStore.isNewOtroIngreso = false;
                } else {
                    Alert.error(response.data.message)
                }
                this.recaudacionStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.recaudacionStore.loading = false;
            }
        })
    }

    public async getConsumoAgua(data: any) {
        this.recaudacionStore.loading = true;
        await http.get("getConsumoAgua", {params: data}).subscribe({
            next: (response) => {
                if (response.data.success) {
                    this.recaudacionStore.facturaConsumoAgua = response.data.factura;
                    this.recaudacionStore.facturaConsumoAgua.facturas.map(item => {
                        item.selected = item.selected == "1";
                    })
                    this.recaudacionStore.isNewConsumoAgua = false;
                } else{
                    const cliente = response.data.cliente;
                    let html=''
                    if (cliente) {
                        html = '<h3 style="color: red">Cliente: '+cliente.nombre+'</h3>'
                        html += '<h4 style="color: red">Ci: '+cliente.ci+'</h4>'
                        html += '<h4 style="color: red">Cuenta: '+cliente.cuenta+'</h4>'
                    }else{
                        html = '<h2 style="color: red">Cuenta no encontrada</h2>'
                    }
                    Alert.info(response.data.message+html)
                }

                this.recaudacionStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.recaudacionStore.loading = false;
            }
        })
    }

    public async getCuentas() {
        await http.get("getCuentas").subscribe({
            next: (response) => {
                this.recaudacionStore.cuentas = response.data;
                this.recaudacionStore.cuentas.map(item => {
                    item.info = `${item.codigo} | ${item.concepto}`
                })
            }
        })
    }

    public async pagarOtroIngreso(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.recaudacionStore.loading = true;
            http.post("pagarOtrosIngresos", data).subscribe({
                next: (response) => {
                    this.recaudacionStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Pago registrado correctamente");
                        this.recaudacionStore.facturaPrintOtroIngreso = response.data.factura;
                        this.getResumen();
                        resolve(true);
                    } else {
                        Alert.error(response.data.message)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.recaudacionStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async pagarConsumo(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.recaudacionStore.loading = true;
            http.post("pagarConsumo", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.recaudacionStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Pago(s) registrado(s) correctamente");
                        this.recaudacionStore.facturaPrintConsumo = response.data;
                        this.getResumen();
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.recaudacionStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async getHistorial(cobranzaId: number) {
        const data = {cobranzaId: cobranzaId}
        await http.get("historiales", {params: data}).subscribe({
            next: (response: AxiosResponse) => {
                this.recaudacionStore.historiales = response.data;
            }
        })
    }

    public async getResumen(fecha:any= DateTime.now().toFormat('yyyy-MM-dd')) {
        this.recaudacionStore.loading = true;
        // await http.get("getResumen").subscribe({
        //     next: (response: AxiosResponse) => {
        //         console.log(response.data)
        //         this.recaudacionStore.resumen = response.data;
        //         this.recaudacionStore.loading = false;
        //     }
        // })
        // console.log(this.globalStore.user)
        await http.post("getArqueoCajeroFecha",{
            fecha: fecha,
            ventanilla: this.globalStore.user.cajero?.ventanilla
        }).subscribe({
            next: (response: AxiosResponse) => {
                this.recaudacionStore.resumen = response.data;
                this.recaudacionStore.loading = false;
            }
        })
    }

    public async getCliente(ci: string) {
        const data = {ci: ci}
        await http.get("getCliente", {params: data}).subscribe({
            next: (response: AxiosResponse) => {
                if (response.data.success) {
                    this.recaudacionStore.facturaOtroIngreso.cliente.nombre = response.data.cliente.razon_social
                    //this.recaudacionStore.facturaOtroIngreso.cliente.direccion = response.data.cliente.direccion
                    this.recaudacionStore.facturaOtroIngreso.cliente.email = response.data.cliente.email
                }
            }
        })
    }
}
